/**
 * Route segment for this view. Ki.CL owns the URL, so the page can say it's
 * unavailable when the moonshot remote can't be loaded.
 */
const PATH = 'moonshot';

export { PATH };
